<div class="modal">
  <section class="modal__section">
    @if (modal.showCloseButton()) {
      <button class="modal__close" aria-label="Cerrar modal"
      (click)="modal.close()">&times;</button>
    }
    @if (modal.child(); as cmp) {
      <ng-container *ngComponentOutlet="cmp;inputs: modal.params()"></ng-container>
    }
  </section>
</div>